// src/services/reportsService.js
//
// Updated to include Attendance Analytics from /api/analytics/*
import { api } from './api';

async function downloadFile(path, filename) {
  const baseUrl = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
  const token = localStorage.getItem('access_token');

  const res = await fetch(baseUrl + path, {
    headers: token ? { Authorization: 'Bearer ' + token } : {},
  });
  if (!res.ok) throw new Error('Failed to export report');

  const blob = await res.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export const reportsService = {
  // Executive/Financial Reports (CEO & Finance)
  getExecutiveDashboard: () =>
    api.get('/api/reports/dashboard'),

  getRevenueOverview: () =>
    api.get('/api/reports/revenue'),

  getProfitLoss: (month, year) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month);
    if (year) params.append('year', year);
    const qs = params.toString();
    return api.get('/api/reports/profit-loss' + (qs ? '?' + qs : ''));
  },

  getCashFlow: (month, year) => {
    const params = new URLSearchParams();
    if (month) params.append('month', month);
    if (year) params.append('year', year);
    const qs = params.toString();
    return api.get('/api/reports/cash-flow' + (qs ? '?' + qs : ''));
  },

  getReceivables: () =>
    api.get('/api/reports/receivables'),

  // Attendance Analytics (CEO & HR Manager)
  getAttendanceDashboard: () =>
    api.get('/api/analytics/dashboard'),

  getAttendanceTrend: (month, year) => {
    const qs = new URLSearchParams();
    if (month) qs.append('month', month);
    if (year) qs.append('year', year);
    const qsStr = qs.toString();
    return api.get('/api/analytics/monthly-trend' + (qsStr ? '?' + qsStr : ''));
  },

  getDepartmentStats: () =>
    api.get('/api/analytics/department-stats'),

  // Authenticated Excel downloads (replaces the old broken window.open pattern)
  exportProfitLoss: (month, year) =>
    downloadFile('/api/reports/profit-loss/export/excel?month=' + (month || '') + '&year=' + (year || ''), 'profit_loss_report.xlsx'),

  exportReceivables: () =>
    downloadFile('/api/reports/receivables/export/excel', 'receivables_report.xlsx'),

  exportCashFlow: (month, year) =>
    downloadFile('/api/reports/cash-flow/export/excel?month=' + (month || '') + '&year=' + (year || ''), 'cash_flow_report.xlsx'),
};